import { render, staticRenderFns } from "./ArticlesTable.vue?vue&type=template&id=2f5bd277&"
import script from "./ArticlesTable.vue?vue&type=script&lang=js&"
export * from "./ArticlesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports